import React from 'react';
import connect from 'Shared/connect';
import { translate } from 'Shared/translate';
import * as styles from '../base.scss';
import Button from 'Shared/Button';
import MyMenigoIcon from '../../../MyMenigo/Shared/MyMenigoIcon/MyMenigoIcon';
const LoginMenuRow = (props) => {
    const handleClick = () => {
        window.location.href = '/login';
    };
    return (React.createElement("div", { className: styles.loginWrapper },
        React.createElement(Button, { appearance: "primary", onClick: handleClick },
            React.createElement(MyMenigoIcon, { name: 'user' }),
            React.createElement("span", null, translate('/Account/Login/Login')))));
};
export default connect((state) => ({
    isLoggedIn: !!state.currentUser && state.currentUser.isLoggedIn,
}))(LoginMenuRow);
